import { PRESET } from "../lib/lighting-presets";

interface RoomLightProps {
  position: [number, number, number];
  panelSize?: [number, number, number];
  utility?: boolean;
}

export default function RoomLight({ position, panelSize, utility }: RoomLightProps) {
  const p = PRESET;
  const cfg = utility ? p.utilityRoom : p.mainRoom;
  const size = panelSize ?? (utility ? [2, 0.1, 4] : [3, 0.1, 6]);

  return (
    <>
      <mesh position={position}>
        <boxGeometry args={size} />
        <meshStandardMaterial
          color="#ffffff"
          roughness={0.3}
          emissive="#ffffff"
          emissiveIntensity={cfg.panelEmissive}
        />
      </mesh>
    </>
  );
}
